import React from "react";
import { styled, css } from "../stitches.config";
import { h3, h4 } from "../redesign/commonStyles/Fonts";

import Media from "./common/Media";
import useMediaQuery from "../helpers/useMediaQuery";
import Timer from './common/Timer'
import CollectionTileForm from "../redesign/Modal/payment/CollectionTileForm"

const CollectionTile = props => {
  const { article, voteFinished = false } = props;
  const imageHeight = (props.imageHeight ? props.imageHeight : (window.innerWidth > 991 ? 456 : 502));
  var imgUrl = article.picture.img;
  imgUrl = imgUrl.replace("780,0,0,0", "0," + imageHeight + ",0,0");
  const amount = voteFinished ? article.progress?.reqAmount : article.progress?.amount ? article.progress?.amount : 0;
  //const progress = Math.round(amount / article.progress?.reqAmount * 10000) / 100;

  const isDesktop = useMediaQuery('bp4');
  const isBigDesktop = useMediaQuery('bp5');
  const mobileHeightRatio = 1.5;
  const desktopHeightRatio = isBigDesktop ? 1.5 : 0.92;

  const progress = Math.round((amount / article.progress?.reqAmount) * 100) || 0;
  const partnerFixedProgress = Math.round((article.progress?.amountNaTemat / article.progress?.reqAmount) * 100) || 0;

  console.log("article: " + article);

  return (

    <BoxWrapper>
      <TileWrapper>

        <LeftColumn>
          <Media
            src={imgUrl}
            preserveRatio={false}
            aspectRatio={isDesktop ? desktopHeightRatio : mobileHeightRatio}
          />
        </LeftColumn>

        <RightColumn>
          <h3 className={isBigDesktop ? h3() : h4()}>{article.title}</h3>
          <Line />

          <HeadingAmount className="heading-amount">
            <h2>{amount} zł</h2>{" "}
            <h4 className={h4()}>
              <b>z {article.progress?.reqAmount || 0} zł</b>
            </h4>
          </HeadingAmount>

          <ProgressBar
            css={{
              marginTop: 20,
              "&:after": {
                left: `${partnerFixedProgress}%`,
                maxWidth: `${100 - partnerFixedProgress}%`,
                width: `${progress - partnerFixedProgress}%`,
              },
              "&:before": { width: `${partnerFixedProgress}%` }
            }}
          />

          <Contributions>
            <Contribution contribution="naTemat">
              <p>Wkład naTemat </p>
            </Contribution>
            <Contribution contribution="readers">
              <p>Wkład czytelników</p>
            </Contribution>
          </Contributions>

          {/*<BridDonationProgress blockData={} /> */}
          <CollectionTileForm article={article} />

          <Status className="status">
            {voteFinished ? (
              <>
                <p>Zbiórka została zakończona.</p>
                <p>Materiał jest już w realizacji.</p>
              </>
            ) : (
              <>
                <p>Do końca zbiórki:</p>
                <p>
                  <Timer finishTime={article.time} />
                </p>
              </>
            )}
          </Status>
        </RightColumn>
      </TileWrapper>
    </BoxWrapper>
  );
};

const BoxWrapper = styled("div", {
  marginBottom: "8px",
  "@bp4": {
    marginBottom: "88px",
  }
})

const TileWrapper = styled("div", {
  "@bp4": {
    display: "flex",
    minHeight: "560px",
  },
})

const HeadingAmount = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "baseline",
  width: "100%",
  "& h2": {
    lineHeight: "42px",
    color: "#fff",
    margin: 0,
    marginRight: "8px",
    fontSize: "38px",
    fontWeight: 700,
  },
  "& h4": {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.2px",
    color: "#8D8D8D",
  }
})

const RightColumn = styled("div", {
  background: "$grayscale100Fixed",
  color: "$grayscale0Fixed",
  width: "100%",
  padding: "24px",
  "@bp4": {
    padding: "24px",
  },
  "@bp5": {
    padding: "24px 48px 48px 48px",
  },
  "& h3": {
    "@bp4": {
      maxHeight: "72px",
      overflow: "hidden",
    },
    "@bp5": {
      maxHeight: "90px",
    },
  }
})

const LeftColumn = styled("div", {
  width: "100%",
  height: "218px",
  "@bp3": {
    height: "500px",
  },
  "@bp4": {
    height: "auto",
    flexShrink: 0,
    width: "516px"
  },
  "@bp5": {
    flexShrink: 0,
    width: "800px"
  },
  "& img": {
    width: "100%",
  }
})

const Line = styled("div", {
  width: "100%",
  height: "1px",
  background: "$grayscale0Fixed",
  opacity: "0.1",
})

const ProgressBar = styled("div", {
  position: "relative",
  width: "100%",
  height: "6px",
  borderRadius: "5px",
  backgroundColor: "#272424",
  "&:before": {
    content: '',
    position: "absolute",
    top: "0",
    left: "0",
    height: "4px",
    borderRadius: "5px 0 0 5px",
    backgroundColor: "$primary",
    border: "3px solid $primary",
  },
  "&:after": {
    content: "",
    position: "absolute",
    top: "0",
    height: "4px",
    borderRadius: "0 5px 5px 0",
    backgroundColor: "#fff",
    border: "3px solid #fff",
  },
  "@bp4": {
    width: "100%",
    margin: 0,
  }
})

const Contributions = styled("div", {
  marginTop: "16px",
  width: "100%",
  "@bp4": {
    display: "flex",
  }
})

const Contribution = styled("div", {
  display: "flex",
  p: {
    color: "#CCCCCC",
    margin: "0",
    fontSize: "14px",
    marginRight: "20px",
  },
  "&:before": {
    content: "",
    width: "12px",
    height: "12px",
    borderRadius: "3px",
    marginRight: "8px",
    marginTop: "3px",
  },
  variants: {
    contribution: {
      naTemat: {
        "&:before": {
          backgroundColor: "$primary",
        },
      },
      readers: {
        "&:before": {
          backgroundColor: "#fff",
        },
      },
    },
  },
});

const Status = styled("div", {
  position: "relative",
  display: "block",
  textAlign: "center",
  width: "100%",
  zIndex: 2,
  marginTop: "20px",
  "& p": {
    color: "#8d8d8d",
    fontSize: "14px",
    margin: 0,
    "&:last-child": {
      color: "#f5f5f5"
    }
  }
});

export default CollectionTile;
